import { useAppStore } from "@/store/appStore";
import ShareDialog from "../dialog/share-dialog";
import Joystick from "../controls/exploration/joystick";
import Image from "@/components/image";
import Text from "@/components/text/text";
import ExplorationHeader from "../controls/exploration/exploration-header";
import ExplorationSideControl from "../controls/exploration/exploration-side-control";
import ExploreIndoorPage from "./exploration";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { CHAT_TYPE } from "@/types/navigation-mode";
import { useExplorationStore } from "@/store/explorationStore";
// import { getVenueModelConfig } from "@/const/venue_model/venue_model_config";
import { getVenueModelConfigByVenueCode, getVenueIdByVenueCode, getBaseUrl } from "src/utils/map-util";
import TopViewButton from "../button/top-view-button";


const ExplorationLayout = ({ children }: { children: React.ReactNode }) => {
  const { venueCode } = useParams();
  const chatType = useAppStore((state) => state.chatType);
  const setChatType = useAppStore((state) => state.setChatType);
  const setCurrentSplat = useExplorationStore((state) => state.setCurrentSplat);
  const setCurrentVenue = useExplorationStore((state) => state.setCurrentVenue);

  const setPositionJoystickData = useExplorationStore(
    (state) => state.setPositionJoystickData,
  );
  const setRotationJoystickData = useExplorationStore(
    (state) => state.setRotationJoystickData,
  );

  const BASE_URL = getBaseUrl();

  useEffect(() => {
    if (chatType != CHAT_TYPE.EXPLORATION) {
      setChatType(CHAT_TYPE.EXPLORATION);
      if (venueCode) {
        const venueModelConfig = getVenueModelConfigByVenueCode(venueCode);
        if(venueModelConfig){
          setCurrentSplat(BASE_URL + venueModelConfig.folderPath + venueModelConfig.mainSplat);
        }
        setCurrentVenue(venueCode);
      }
    }
  }, [chatType]);

  const handlePositionJoystickMove = (x: number, y: number) => {
    // console.log(`Joystick position: x=${x}, y=${y}`);
    // setPositionJoystickX(x);
    // setPositionJoystickY(y);
    setPositionJoystickData([x, y]);
  };

  const handlePositionJoystickRelease = () => {
    console.log("release");
    // setPositionJoystickX(0);
    // setPositionJoystickY(0);
    setPositionJoystickData([0, 0]);
  };

  const handleRotationJoystickMove = (x: number, y: number) => {
    setRotationJoystickData([x, y]);
  };

  const handleRotationJoystickRelease = () => {
    setRotationJoystickData([0, 0]);
  };

  const Joysticks = () => {
    return (
      <div className="absolute bottom-0 left-0 right-0">
        <div className="flex fixed justify-between bottom-0 w-full px-[20px] mb-[20px]">
          <Joystick
            onMove={handlePositionJoystickMove}
            onRelease={handlePositionJoystickRelease}
            topChild={
              <Image
                src="/assets/icon_joystick_up.png"
                height={24}
                width={24}
              />
            }
            bottomChild={
              <Image
                src="/assets/icon_joystick_down.png"
                height={24}
                width={24}
              />
            }
            leftChild={
              <Image
                src="/assets/icon_joystick_left.png"
                height={24}
                width={24}
              />
            }
            rightChild={
              <Image
                src="/assets/icon_joystick_right.png"
                height={24}
                width={24}
              />
            }
          />
          <Joystick
            onMove={handleRotationJoystickMove}
            onRelease={handleRotationJoystickRelease}
            topChild={<Text text="joystick_up" size={10} />}
            bottomChild={<Text text="joystick_down" size={10} />}
            leftChild={
              <Image
                src="/assets/icon_joystick_rotate_left.png"
                height={20}
                width={20}
              />
            }
            rightChild={
              <Image
                src="/assets/icon_joystick_rotate_right.png"
                height={20}
                width={20}
              />
            }
          />
        </div>
      </div>
    );
  };

  const Share = () => {
    const isShareOpen = useAppStore((state) => state.isShareOpen);
    return isShareOpen ? <ShareDialog /> : <></>;
  };

  const ExplorationUI = () => {
    const [_isDisplayUI, _setIsDisplayUI] = useState<boolean>(false);

    const setIsDisplayUI = useExplorationStore((state) => state.setIsDisplayUI);
    const isDisplayUI = useExplorationStore((state) => state.isDisplayUI);

    useEffect(()=>{
      _setIsDisplayUI(isDisplayUI);
    },[isDisplayUI])

    return _isDisplayUI ? (
      <>
        {venueCode && <ExplorationHeader venueCode={venueCode} />}
        <Joysticks />
        <div className="absolute bottom-[184px] md:bottom-40 right-0">
          <ExplorationSideControl />
        </div>
        <div className="absolute bottom-[184px] md:bottom-[20%] left-0 m-6 mb-[20px] md:mb-[35px]">
          <TopViewButton />
        </div>

        <Share />
      </>
    ) : (
      <></>
    );
  };

  return (
    <div className="fullscreen_div">
      {children}
      <ExplorationUI />
    </div>
  );
};

const Explore3DPage: React.FC = () => {
  return (
    <ExplorationLayout children={<ExploreIndoorPage />}></ExplorationLayout>
  );
};

export default Explore3DPage;
